import { render } from "./add-room.vue?vue&type=template&id=05b4ee77&scoped=true&lang=pug"
import script from "./add-room.vue?vue&type=script&lang=js"
export * from "./add-room.vue?vue&type=script&lang=js"

import "./add-room.vue?vue&type=style&index=0&id=05b4ee77&lang=scss&scoped=true"
import "./add-room.vue?vue&type=style&index=1&id=05b4ee77&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b4ee77"]])

export default __exports__